import { Box, Button, Divider, Grid, useTheme } from '@mui/material'
import React, { useEffect, useState } from 'react'
import AppsIcon from '@mui/icons-material/Apps'
import PrintIcon from '@mui/icons-material/Print'
import PdfIcon from '@mui/icons-material/PictureAsPdf'
import ExcelIcon from '@mui/icons-material/FileCopy'
import { transparentStyle } from '../../../DeliveryMemo/const'
import { addMisssingValueForDetailed, calculateDynamicFormatLandscape, calculateDynamicFormatPortrait, calculateTotalTableWidth, clickElement, focusElemnt, generateDynamicColumnStyles, navigation3 } from '../../../../common/helper'
import ReactHtmlTableToExcel from 'react-html-table-to-excel'
import moment from 'moment'
import { callAddFontRobotoBold } from '../../../../common/font/Roboto-bold'
import { callAddFontRobotoNormal } from '../../../../common/font/Roboto-normal'
import jsPDF from 'jspdf'
import autoTable from 'jspdf-autotable'
import * as sx from '../../../../common/stylesInline/report_daily_branch'
import WithVehicleAndChartTable from './WithVehicleAndChartTable'
import { exportToExcel } from '../../../../common/hook'
import { makeTable } from '../../analysisReport/pdfAutotable'

const WithVehicleAndChart = ({ updateModal, disableExcel, loginData, selBranch, selDestCity, selFromBranch, columnDefs, reportData, selectedFields, toDate, fromDate, selVehicle, selPaymentTpe, reportType, showSummaryReport, detailedFilter }) => {
    const headers = columnDefs.map((item) => {
      return {
        header: item.header,
        field: item.field,
        headerSx: item.headerSx,
        textAlign: item.headerSx?.textAlign || 'left',
      }
    })
    const excelColumns = headers.map((item) => {
      return {
        ...item,
        header: item.header?.replace(/\n+/g, ' '),
      }
    })
    const theme = useTheme()
    const [showTable, setShowTable] = useState(true)
    const [tableData, setTableData] = useState([])
    const [state, setState] = useState({
        startIndex: 0,
        lastIndex: 8,
        Total: 0,
        TotalAmount: 0,
        generatePDF: false,
        load: false,
    })
    const { generatePDF, load } = state
    const currentDateTime = moment(window.getTime ? window.getTime() : new Date()).format('DD-MMM-YYYY HH:mm');
    useEffect(() => {
        if (reportData?.length > 0) {
            const updatedData=addMisssingValueForDetailed(reportData)
            setTableData(groupTableData(updatedData,headers))
        } else {
            setTableData([{ isNoData: true, caption: 'No results found. Please refine your search parameters and search again.' }])
        }
    }, [reportData])
    const groupTableData = (data, headers) => {
      const grouped = data.reduce((acc, item) => {
        const key = [
          item.VehicleNo,
          item.SummaryFromCityID,
          item.SummaryFromBranchID,
          item.SummaryToCityID,
          item.SummaryToBranchID,
          item.SummaryDispatchDateTime,
        ].join('-')

        ;(acc[key] ||= []).push(item)
        return acc
      }, {})

      const rows = Object.values(grouped).flatMap(groupData)

      const numericFields = [
        'topayCount',
        'paidCount',
        'onAccountCount',
        'focCount',
        'topaydddvCount',
        'totalLR',
        'totalQuantity',
        'totalToPayCodFreight',
        'totalpaidFreight',
        'totalOnAccountFreight',
        'totalFocFreight',
        'totalDddvFreight',
        'totalFreight',
        'totalToPayCodGstOther',
        'totalpaidGstOther',
        'totalOnAccountGstOther',
        'totalFocGstOther',
        'totalTopayDddvGstOther',
        'totalGstOther',
        'totalNetAmount',
      ]

      const totals = Object.fromEntries(numericFields.map((f) => [f, 0]))

      rows.forEach((r) => {
        numericFields.forEach((f) => {
          const val = +r[f]
          if (!isNaN(val)) totals[f] += val
        })
      })
      Object.keys(totals).forEach((k) => (totals[k] = Number(totals[k].toFixed(2))))
      return [
        ...rows,
        {
          dataType: 'total',
          [headers[0].field]: 'TOTAL',
          align: { [headers[0].field]: 'right' },
          colSpan: { [headers[0].field]: 3 },
          ...totals,
        },
      ]
    }
    const groupData = (data) => {
      const first = data[0]
      const numericFields = {
        totalLR: 0,
        totalQuantity: 0,
        totalToPayCodFreight: 0,
        totalpaidFreight: 0,
        totalOnAccountFreight: 0,
        totalFocFreight: 0,
        totalDddvFreight: 0,
        totalFreight: 0,
        totalToPayCodGstOther: 0,
        totalpaidGstOther: 0,
        totalOnAccountGstOther: 0,
        totalFocGstOther: 0,
        totalTopayDddvGstOther: 0,
        totalGstOther: 0,
        totalNetAmount: 0,
      }
      const paymentMap = {
        1: 'paidCount',
        6: 'paidCount',
        2: 'topayCount',
        4: 'topayCount',
        7: 'topayCount',
        3: 'focCount',
        8: 'focCount',
        5: 'onAccountCount',
        10: 'onAccountCount',
        9: 'topaydddvCount',
      }
      const counters = {
        paidCount: 0,
        topayCount: 0,
        onAccountCount: 0,
        focCount: 0,
        topaydddvCount: 0,
      }
      data.forEach((obj) => {
        const bucket = paymentMap[obj.PaymentTypeInt]
        if (bucket) counters[bucket]++
        numericFields.totalLR++
        numericFields.totalQuantity += +obj.Quantity || 0
        numericFields.totalNetAmount += +obj.SummaryNetAmount || 0
        numericFields.totalToPayCodFreight += +obj.ToPayCodFreight || 0
        numericFields.totalpaidFreight += +obj.paidFreight || 0
        numericFields.totalOnAccountFreight += +obj.OnAccountFreight || 0
        numericFields.totalFocFreight += (+obj.FocFreight || 0) + (+obj.SelfFreight || 0)
        numericFields.totalDddvFreight += +obj.DddvFreight || 0
        numericFields.totalFreight += +obj.totalFreight || 0
        numericFields.totalToPayCodGstOther += +obj.ToPayCodGstOther || 0
        numericFields.totalpaidGstOther += +obj.paidGstOther || 0
        numericFields.totalOnAccountGstOther += +obj.OnAccountGstOther || 0
        numericFields.totalFocGstOther += +obj.FocGstOther || 0
        numericFields.totalTopayDddvGstOther += +obj.TopayDddvGstOther || 0
        numericFields.totalGstOther += +obj.totalGstOther || 0
      })

      Object.keys(numericFields).forEach((k) => (numericFields[k] = Number(numericFields[k].toFixed(2))))

      return [
        {
          dataType: 'entry',
          VehicleNo: first?.VehicleNo,
          SummaryFromCity: first?.SummaryFromCity,
          SummaryToCity: first?.SummaryToCity,
          DispatchDateTime: first?.DispatchDateTime,
          SummaryDriverConductorName: first?.SummaryDriverConductorName,
          ...counters,
          ...numericFields,
        },
      ]
    }
    const printReport = (isSave = false) => {
        setShowTable(false)
        setState({ ...state, load: true, generatePDF: true })
        const widthCell = calculateTotalTableWidth(columnDefs)

        jsPDF.API.events.push(['addFonts', callAddFontRobotoBold])
        jsPDF.API.events.push(['addFonts', callAddFontRobotoNormal])
        const doc = new jsPDF({ orientation: headers.length > 12 ? 'l' : 'p', format: headers.length > 12 ? calculateDynamicFormatLandscape((widthCell > 1122 ? widthCell : 1122) + 60) : calculateDynamicFormatPortrait((widthCell > 1000 ? widthCell : 1000) + 60), unit: 'px', compress: true })
        doc.setProperties({
            title: `Vehicle wise Dispatch.pdf`,
            subject: 'Vehicle wise Dispatch Report',
            author: 'Maven Tech Labs Pvt. Ltd.',
            keywords: 'maven tech, Cargo system, LRWise',
            creator: 'MTLPL',
        })
        var pageSize = doc.internal.pageSize
        var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight()
        var pageWidth = pageSize.width ? pageSize.width : pageSize.getWidth()
        var scaleFactor = pageWidth / (headers.length > 12 ? 1122 : 793);
        var totalPagesExp = '{total_pages_count_string}'
        const jsPdfHeaderFooter = (data, userData, totalPagesExp) => {
            const doc = data.doc
            // Footer
            var str = 'Page : ' + doc.internal.getNumberOfPages()
            if (typeof doc.putTotalPages === 'function') {
                str = str + ' of ' + totalPagesExp
            }
            doc.setFontSize(scaleFactor * 14)
            doc.text(str, doc.internal.pageSize.width - data.settings.margin.left + 130, pageHeight - 5, "right")
            doc.setFont('Roboto', 'bold')
            doc.text(`Report By : ${userData.strUserName} [ ${userData.strBranchName} ]`, 30, pageHeight - 5)
            doc.text(`Report Time : ${moment(new Date()).format('DD MMM YYYY, ddd, HH:mm')}`, (doc.internal.pageSize.width / 2) - (doc.getStringUnitWidth(`Report Time : ${moment(new Date()).format('DD MMM YYYY, ddd, HH:mm')}`) * doc.internal.getFontSize() / 2) + 90, pageHeight - 5)
        }
        const HeaderColumn = [
            {
                headerName: 'Dispatch By Branch',
                exportHead: 'Dispatch By Branch',
                field: 'selFromBranch',
                xlCol: { dataType: 'string', dataFormatter: null },
            },
            {
                headerName: 'Destination City',
                exportHead: 'Destination City',
                field: 'selDestCity',
                xlCol: { dataType: 'string', dataFormatter: null },
            },
            {
                headerName: 'Destination Branch',
                exportHead: 'Destination Branch',
                field: 'selBranch',
                xlCol: { dataType: 'string', dataFormatter: null },
            },
            {
                headerName: 'Vehicle Number',
                exportHead: 'Vehicle Number',
                field: 'selVehicle',
                xlCol: { dataType: 'string', dataFormatter: null },
            },
        ]
        const HeaderColumns = HeaderColumn.map((col) => {
            return { header: col.exportHead, dataKey: col.field, xlCol: col.xlCol }
        })
        const HeaderData = [
            {
                selFromBranch: selFromBranch?.name || loginData?.strBranchName,
                selDestCity: selDestCity?.name,
                selBranch: selBranch?.name,
                selVehicle: selVehicle?.name,
                selPaymentTpe: selPaymentTpe?.name || 'All',
                reportType: reportType?.Name,
                showSummaryReport: showSummaryReport?.Name,
                detailedFilter: detailedFilter?.Name,
            },
        ]
        autoTable(doc, {
            margin: { top: 60, left: 30, right: 30, bottom: 5 },
            alternateRowStyles: {
                fillColor: [255, 255, 255],
            },
            columns: HeaderColumns,
            body: HeaderData,
            startY: 160,
            theme: 'grid',
            headStyles: {
                fillColor: [191, 225, 255],
                textColor: [0, 0, 0],
                minCellHeight: 36,
                valign: 'middle',
                cellPadding: 12,
                fontSize: scaleFactor * 14,
                fontStyle: 'normal',
                font: 'Roboto',
                lineWidth: 0.6,
            },
            columnStyles: {
                0: { fontSize: scaleFactor * 14, textColor: [0, 0, 0], cellPadding: 12, minCellHeight: 36, minCellWidth: columnDefs.length > 12 ? 350 : 250, valign: 'middle', font: 'Roboto', fontStyle: 'normal', halign: 'left' },
                1: { fontSize: scaleFactor * 14, textColor: [0, 0, 0], cellPadding: 12, minCellHeight: 36, minCellWidth: columnDefs.length > 12 ? 350 : 250, valign: 'middle', font: 'Roboto', fontStyle: 'normal', halign: 'left' },
                2: { fontSize: scaleFactor * 14, textColor: [0, 0, 0], cellPadding: 12, minCellHeight: 36, minCellWidth: columnDefs.length > 12 ? 350 : 250, valign: 'middle', font: 'Roboto', fontStyle: 'normal', halign: 'left' },
                3: { fontSize: scaleFactor * 14, textColor: [0, 0, 0], cellPadding: 12, minCellHeight: 36, minCellWidth: columnDefs.length > 12 ? 350 : 250, valign: 'middle', font: 'Roboto', fontStyle: 'normal', halign: 'left' },
            },
            didDrawPage: function (data) {
                doc.setTextColor(0, 0, 0)
                doc.setFontSize(scaleFactor * 16).setFont('Roboto', 'bold')
                doc.text(`From Dispatch : ${moment(fromDate).format('DD-MMM-YYYY')} To ${moment(toDate).format('DD-MMM-YYYY')}`, data.settings.margin.left, 150)
                doc.text(`Detailed-With Vehicle And Chart Date`, doc.internal.pageSize.width - data.settings.margin.left, 150, "right")
                jsPdfHeaderFooter(data, loginData, totalPagesExp)
            },
            showHead: "firstPage",
        })
        const HeaderColumns1 = [
            {
                header: 'Payment Type',
                dataKey: 'selPaymentTpe',
                xlCol: { dataType: 'string', dataFormatter: null },
            },
            {
                header: 'Report Type',
                dataKey: 'reportType',
                xlCol: { dataType: 'string', dataFormatter: null },
            },
            {
                header: 'Report View',
                dataKey: 'showSummaryReport',
                xlCol: { dataType: 'string', dataFormatter: null },
            },
            {
                header: 'Report Option',
                dataKey: 'detailedFilter',
                xlCol: { dataType: 'string', dataFormatter: null },
            },
        ]

        autoTable(doc, {
            margin: { top: 60, left: 30, right: 30, bottom: 5 },
            alternateRowStyles: {
                fillColor: [255, 255, 255],
            },
            columns: HeaderColumns1,
            body: HeaderData,
            startY: doc.lastAutoTable.finalY,
            theme: 'grid',
            headStyles: {
                fillColor: [191, 225, 255],
                textColor: [0, 0, 0],
                minCellHeight: 36,
                valign: 'middle',
                cellPadding: 12,
                fontSize: scaleFactor * 14,
                fontStyle: 'normal',
                font: 'Roboto',
                lineWidth: 0.6,

            },
            columnStyles: {
                0: { fontSize: scaleFactor * 14, textColor: [0, 0, 0], cellPadding: 12, minCellHeight: 36, minCellWidth: columnDefs.length > 12 ? 350 : 250, valign: 'middle', font: 'Roboto', fontStyle: "normal", halign: 'left' },
                1: { fontSize: scaleFactor * 14, textColor: [0, 0, 0], cellPadding: 12, minCellHeight: 36, minCellWidth: columnDefs.length > 12 ? 350 : 250, valign: 'middle', font: 'Roboto', fontStyle: "normal", halign: 'left' },
                2: { fontSize: scaleFactor * 14, textColor: [0, 0, 0], cellPadding: 12, minCellHeight: 36, minCellWidth: columnDefs.length > 12 ? 350 : 250, valign: 'middle', font: 'Roboto', fontStyle: "normal", halign: 'left' },
                3: { fontSize: scaleFactor * 14, textColor: [0, 0, 0], cellPadding: 12, minCellHeight: 36, minCellWidth: columnDefs.length > 12 ? 350 : 250, valign: 'middle', font: 'Roboto', fontStyle: "normal", halign: 'left' },
            },
            showHead: "firstPage",
        })
        const pdfColumns = columnDefs.map((col) => {
            return { header: col.pdfHead, dataKey: col.field, xlCol: col.xlCol }
        })
        makeTable(doc, autoTable, pdfColumns, tableData, 1.7, 'with vehicle and chart date', loginData, 'everyPage', ()=>{}, 120, false)
        doc.setFont('Roboto')
        if (typeof doc.putTotalPages === 'function') {
            doc.putTotalPages(totalPagesExp)
        }
        if (isSave) {
            doc.save(`With Vehicle And Chart Date ${currentDateTime}.pdf`)
        }
        setTimeout(() => {
            setState({ ...state, generatePDF: false, load: true })
            const pdfUrl = doc.output('bloburl')
            document.getElementById('output').data = pdfUrl
            // document.getElementById('output').data = doc.output('datauristring', 'With Vehicle And Chart Date.pdf')
            focusElemnt('DispatchBackBtn')
        }, 2000)
    }
    return (
        <>
            <div
                className="print-input-btn"
                style={{ display: 'flex', alignItems: 'center', justifyContent: 'end', padding: '12px 16px', width: '100%', marginBottom: '-10px' }}
            >
                {showTable ? (
                    <>
                        <Box style={{ display: 'flex', width: '100%', height: '32px', padding: '12px 0px', marginRight: '0px' }}>
                            <Box
                                style={{ display: 'flex', width: '50%', justifyContent: 'flex-start', alignItems: 'center', gap: '12px', fontSize: '14px' }}
                            >
                                <h3 style={{ textAlign: 'left', color: '#444' }}>
                                    Detailed View - With Vehicle And Chart Date
                                </h3>
                                <Box
                                    style={{
                                        height: '32px',
                                        display: 'flex',
                                        padding: '8px 12px',
                                        justifycontent: 'center',
                                        alignitems: 'center',
                                        gap: '6px',
                                    }}
                                    id="dispatchReportManageColumn"
                                    tabIndex={0}
                                    onClick={() => updateModal(true, 'showManageColumn')}
                                >
                                    <span tabIndex={0} style={{ display: 'flex', margin: '-3px' }}>
                                        <AppsIcon />
                                    </span>
                                    <span tabIndex={0} style={{ fontWeight: 'bold' }}>
                                        MANAGE COLUMNS
                                    </span>
                                </Box>
                            </Box>
                            <Box
                                style={{
                                    display: 'flex',
                                    width: '50%',
                                    justifyContent: 'end',
                                    alignItems: 'center',
                                }}
                            >
                                <Grid item xs={6} md={2}>
                                    <Button
                                        id='DispatchPrintBtn'
                                        startIcon={<PrintIcon />}
                                        variant="contained"
                                        color="primary"
                                        style={{ ...transparentStyle(theme), fontSize: '100%' }}
                                        onClick={() => {
                                            setShowTable(false)
                                            printReport()
                                        }}
                                        onKeyDown={(e) => navigation3(e, disableExcel ? "DispatchPdfBtn" : "xls-button-dispatch", "generateBtn", () => { })}

                                    >
                                        Print
                                    </Button>
                                </Grid>
                                <Divider
                                    orientation="vertical"
                                    flexItem
                                    style={{ width: '2px', margin: '0', height: '15px', alignSelf: 'center', backgroundColor: '#ccc' }}
                                />
                                {
                                    disableExcel ? null
                                        : <Grid item xs={6} md={2}>
                                            <Button
                                                onKeyDown={(e) => navigation3(e, 'DispatchPdfBtn', 'DispatchPrintBtn', () => { })}
                                                id='xls-button-dispatch'
                                                startIcon={<ExcelIcon />}
                                                variant="contained"
                                                color="primary"
                                                style={{ ...transparentStyle(theme), fontSize: '100%' }}
                                                onClick={(e) => {
                                                    e.preventDefault()
                                                    exportToExcel({
                                                      fileName: `Dispatch Report (With Vehicle And Chart Date) ${currentDateTime}.xlsx`,
                                                      sheetName: 'WithVehicleAndChart',
                                                      headersList: [excelColumns],
                                                      dataList: [tableData],
                                                    })  
                                                }}
                                            >
                                                EXPORT AS EXCEL
                                            </Button>
                                        </Grid>
                                }

                                <Divider
                                    orientation="vertical"
                                    flexItem
                                    style={{ width: '2px', margin: '0', height: '15px', alignSelf: 'center', backgroundColor: '#ccc' }}
                                />
                                <Button
                                    startIcon={<PdfIcon />}
                                    id='DispatchPdfBtn'
                                    onKeyDown={(e) => navigation3(e, 'fromDate', "xls-button-dispatch", () => { })}
                                    variant="contained"
                                    color="primary"
                                    style={{ ...transparentStyle(theme), fontSize: '100%' }}
                                    onClick={() => {
                                        setShowTable(false)
                                        printReport(true)
                                    }}
                                >
                                    Export as PDF
                                </Button>
                            </Box>
                        </Box>
                    </>
                ) : (
                    <>
                        <Box className="export-as-pdf" style={{ paddingTop: '7px' }}>
                            <Button
                                variant="contained"
                                id='DispatchBackBtn'
                                onKeyDown={(e) => navigation3(e, 'fromDate', 'generateBtn', () => { })}
                                onClick={() => {
                                    setShowTable(true)
                                    focusElemnt('generateBtn')
                                }}
                                style={{
                                    borderRadius: '5px',
                                    fontWeight: 'bold',
                                    cursor: 'pointer',
                                    fontSize: '15px',
                                    color: '#fe5200',
                                    background: 'white',
                                    marginLeft: '10px',
                                    border: '2px solid #fe5200',
                                }}
                            >
                                BACK
                            </Button>
                        </Box>
                    </>
                )}
            </div>
            {showTable ?
                <WithVehicleAndChartTable
                    loginData={loginData}
                    selBranch={selBranch}
                    selFromBranch={selFromBranch}
                    selDestCity={selDestCity}
                    columnDefs={headers}
                    tableData={tableData}
                    selectedFields={selectedFields}
                    reportType={reportType}
                />
                :
                <>
                    {generatePDF ? <div className={'generatePDF'}>Generating PDF....</div> : ''}
                    {load ? (
                        <Box sx={{ ...sx.reportFlex, justifyContent: 'center' }}>
                            <object
                                id="output"
                                type="application/pdf"
                                width="100%"
                                height="440"
                                title="MTLPL -Cargo System - With Vehicle And Chart Date"
                                aria-label="MTLPL -Cargo System - With Vehicle And Chart Date"
                            ></object>
                        </Box>
                    ) : (
                        ''
                    )}
                </>
            }
        </>
    )
}

export default WithVehicleAndChart